import { render, staticRenderFns } from "./index.vue?vue&type=template&id=636a85cc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/opter/repo/code/cloudsee-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636a85cc')) {
      api.createRecord('636a85cc', component.options)
    } else {
      api.reload('636a85cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=636a85cc", function () {
      api.rerender('636a85cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/WorkOrderTypeSelector/index.vue"
export default component.exports